import { useOutletContext, Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import {Table, Input} from "reactstrap";

import { translations } from './../../../i18/translations.js';
import AdministrationLinkRow from './assets/AdministrationLinkRow.js'
import RadioButtonGroup from './../../../util/RadioButtonGroup.js';
import Search from './../../../util/Search.js';
import Pager from './../../../util/Pager.js';
import { Space } from './../../../util/Html.js';
import './MembershipReportByYear.css';

const MembershipReportByYear = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {user, lang, checkAccess} = useOutletContext();

    const [results, setResults] = useState(null);
    const [query, setQuery] = useState('');
    const [pageIndex, setPageIndex] = useState(0);
    const [year, setYear] = useState(new Date().getFullYear());
    const [selection, setSelection] = useState('1');

    const [pager, setPager] = useState([]);
    const [members, setMembers] = useState([]);
    const [template, setTemplate] = useState('');

    const pageSize = 20;
    const buttons = [
        {title: translations[lang].all, value: '1'},
        {title: translations[lang].paid, value: '2'},
        {title: translations[lang].unpaid, value: '3'}
    ];
    const years = Array.from({length: new Date().getFullYear() - 2005}, (_, i) => 2006 + i);

    useEffect(() => {
        fetchMembers(pageIndex, query, year, selection);
    }, [pageIndex, query, year, selection, user]);

    const handleSearch = (query) => {
        setQuery(query);
        setPageIndex(0);
    };

    const handleSelectionChange = (value) => {
        setSelection(value);
    };

    const handleYearChange = (event) => {
        const newValue = event.target.value;
        setYear(newValue);
    };

    const fetchMembers = async (pageIndex, queryString, year, selection) => {
        try {
            const payload = {
                filter: {
                    pageSize: 20,
                    pageIndex: pageIndex,
                    queryString: queryString,
                    year: year,
                    selection: selection
                }
            };

            const response = await fetch(`${API_URL}/admin/get_administration_report_by_year.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setMembers(data.data);
                setPager(data.pagerButtonIndexes);
                setTemplate(data.template);
            }
        } catch (error) {
            console.error("Error fetching members:", error);
        }
    };

    return (
            <div className="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].membership_report} [{year}]</h1>
            
                <AdministrationLinkRow lang={lang} />
            
                <div className="membership-report-by-year-container mb-3">
                    <Search placeholder={translations[lang].search_member} handleSearch={handleSearch} />
                    <RadioButtonGroup buttons={buttons} onSelectionHandler={handleSelectionChange} initialValue={selection} />
                    <Input value={year} type="select" onChange={handleYearChange}>
                    {years.map((y) => (
                                <option key={y} value={y + ''}>{y}</option>
                                    ))}
                    </Input>
                </div>
            
                <Table striped className="mbkegy-table">
                    <thead>
                        <tr>
                            <th style={{width: '35%'}}>{translations[lang].name}</th>
                            <th style={{width: '65%'}}>{translations[lang].institute}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map((member) => (
                                <tr key={member.id}>
                                    <td style={{color: member.af_id === null ? "darkred" : "darkgreen"}}>{member.fullname ? member.fullname : <Space />}</td>
                            <td style={{color: member.af_id === null ? "darkred" : "darkgreen"}}>{member.institute ? member.institute : <Space />}</td>
                            </tr>
                                    ))}
                    </tbody>
                </Table>
            
                <Pager template={`${translations[lang].rows}: ${template}`} pager={pager} handlePageChange={setPageIndex} />
            
            </div>
            );
};

export default MembershipReportByYear;